export default __webpack_public_path__ + "static/media/avatar_nikki_dog4.d92108e2.mp3";